// Import components
import React, { useMemo, useState , useEffect } from "react";
import Breadcrumbs from '../../../Components/Common/Breadcrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import { subscribeToTokenRefresh } from "../../../helpers/Refreshfile";
import axios from "axios";
import {Alert,Modal, Label, ModalHeader, Card, CardBody, Row, Col, UncontrolledTooltip, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from "classnames";
import defaultUserImg from "../../../assets/images/defaultuserimgdark.png";
import Select from 'react-select';
const baseUrl = process.env.REACT_APP_BASE_URL;



interface column {
    header: string;
    accessorKey?: string;
    accessorFn?: (row: any) => string;
    enableColumnFilter: boolean;
    enableSorting: boolean;
    cell?: (info: any) => React.ReactNode;
}

const AdminPartner = () => {
    const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
    const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
        if (reason === "clickaway") { return; }
        setAlertMsgg({ ...alertMsgg, open: false })
    };
    const [showloader, setshowloader] = useState(true);  // State for tracking submission
    


    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const [modal_center, setmodal_center] = useState(false);
    const [modal_standard_delete_partner, setmodal_delete_partner] = useState(false);
    const [partnerData, setPartnerData] = useState<any[]>([]);
    const [selectedPartnerId, setSelectedPartnerId] = useState<string | null>(null);
    const [modal_standard_edit_partner, setmodal_edit_partner] = useState(false);
    const [modal_view_partner, setmodal_view_partner] = useState(false);
    const [selectedPartnerForView, setSelectedPartnerForView] = useState<any | null>(null);
    const [isAdding, setIsAdding] = useState(false);
    const [activeViewTab, setActiveViewTab] = useState<string>("1");

    console.log('partnerData',partnerData)

    const [selectedDomains, setSelectedDomains] = useState<string[]>([]);
    const [all_domain_data, setalldomaindata] = useState<any[]>([]);
    const [selectedBookkeepingTools, setSelectedBookkeepingTools] = useState<string[]>([]);
    const [selectedTaxTools, setSelectedTaxTools] = useState<string[]>([]);

    // Bookkeeping tools options
    const bookkeepingToolsOptions = [
        { value: 'QuickBooks', label: 'QuickBooks' },
        { value: 'NOVO Bank', label: 'NOVO Bank' },
        { value: 'Excel Sheet', label: 'Excel Sheet' },
        { value: 'Xero', label: 'Xero' },
        { value: 'FreshBooks', label: 'FreshBooks' },
        { value: 'Sage', label: 'Sage' },
        { value: 'Wave', label: 'Wave' },
        { value: 'Zoho Books', label: 'Zoho Books' },
        { value: 'NetSuite', label: 'NetSuite' },
        { value: 'Microsoft Dynamics', label: 'Microsoft Dynamics' },
    ];

    // Tax tools options
    const taxToolsOptions = [
        { value: 'ProConnect (Intuit)', label: 'ProConnect (Intuit)' },
        { value: 'Checkpoint (Thomson Reuters)', label: 'Checkpoint (Thomson Reuters)' },
        { value: 'CCH (Wolters Kluwer)', label: 'CCH (Wolters Kluwer)' },
        { value: 'TurboTax (Intuit)', label: 'TurboTax (Intuit)' },
        { value: 'TaxAct (H&R Block)', label: 'TaxAct (H&R Block)' },
        { value: 'Drake Tax (Drake Software)', label: 'Drake Tax (Drake Software)' },
        { value: 'Lacerte (CCH)', label: 'Lacerte (CCH)' },
        { value: 'ProSeries (CCH)', label: 'ProSeries (CCH)' },
    ];

    // Check if bookkeeping domain is selected
    const isBookkeepingDomainSelected = () => {
        return all_domain_data.some(domain => 
            selectedDomains.includes(domain.id.toString()) && 
            domain.name.toLowerCase().includes('bookkeeping')
        );
    };

    // Check if tax domain is selected
    const isTaxDomainSelected = () => {
        return all_domain_data.some(domain => 
            selectedDomains.includes(domain.id.toString()) && 
            domain.name.toLowerCase().includes('tax')
        );
    };

    function editPartner(id?: string) {
        if (id !== undefined) {
            setSelectedPartnerId(id);
        }
        setmodal_edit_partner(true);
        removeBodyCss();
    }
    

    function closeeditPartner() {
        setmodal_edit_partner(!modal_standard_edit_partner);
        setErrors({ firstname: '', lastname: '', email: '', phone: '', selectedDomains: '' });
        removeBodyCss();
    }


    function deletePartner(id?: string) {
        if (id !== undefined) {
            setSelectedPartnerId(id);
        }
        setmodal_delete_partner(!modal_standard_delete_partner);
        removeBodyCss();
    }

    function viewPartner(partner?: any) {
        console.log("viewPartner called with partner:", partner);
        if (partner) {
            console.log("Setting partner and opening modal");
            setSelectedPartnerForView(partner);
            setActiveViewTab("1");
            setmodal_view_partner(true);
            console.log("Modal state should be true now");
            removeBodyCss();
        } else {
            console.log("Partner is undefined");
        }
    }

    function closeViewPartner() {
        setmodal_view_partner(false);
        setSelectedPartnerForView(null);
        setActiveViewTab("1");
        removeBodyCss();
    }

    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }




    function add_partner() {
        setmodal_center(!modal_center);
        setFormValues({firstname: "",lastname: "",email: "",phone: "",image: null, company_name: ""});
        setSelectedImage(null);
        setSelectedDomains([]);
        setSelectedBookkeepingTools([]);
        setSelectedTaxTools([]);
        setErrors({ firstname: '', lastname: '', email: '', phone: '', selectedDomains: '' });
        removeBodyCss();
    }

    const handleToggle = (id: string) => {
        const createexp = async () => {
        try {
            setshowloader(true)
            const response = await axios.post(`/accounts/user_active_change`,{ role: 'prt', eid: id },);
            if (response.status === "DONE") {
                fetch_partnerlisting();
                setshowloader(false)
                setAlertMsgg({ ...alertMsgg, open: true, content: "User status updated successfully!", type: "success" });
                setPartnerData((prev) =>
                    prev.map((row: any) =>
                    row.id === id ? { ...row, user: { ...row.user, is_active: !row.user.is_active } } : row)
                    );
                setTimeout(() => {
                    setAlertMsgg({...alertMsgg, open: false, content: "", type: ""})
                }, 4000);
    
    
            }
        } catch (error:any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false)
        }
        };
        createexp();
    };
    

    //  img upload
    const handleImageChangeo = (event: any) => {
        event.preventDefault();
        let reader = new FileReader();
        let file = event.target.files[0];
        reader.onloadend = () => {
        setSelectedImage(reader.result as string);
        };
        reader.readAsDataURL(file);
    };

    const columns: column[] = useMemo(
        () => [
            {
                header: 'S.No',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => row.index + 1,
            },
            {
                header: 'Partner Info',
                enableColumnFilter: false,
                enableSorting: true,
                accessorFn: (row: any) => {
                    const first_name = row?.user?.first_name || '';
                    const email = row?.user?.email || '';
                    return `${first_name} ${email}`;
                },
                cell: ({ row }) => {
                    const category = row.original.user;
                    const companyName = row.original.company_name;
                    const date = new Date(row.original.created_at).toLocaleString('en-US', {
                        day: '2-digit', month: 'short', year: 'numeric',
                        hour: '2-digit', minute: '2-digit'
                    });
    
                    return (
                        <div className="d-flex align-items-center">
                            <img
                                src={category.profile_pic
                                ? category.profile_pic
                                : defaultUserImg
                            }
                                alt="User"
                                width="50"
                                height="50"
                                className="rounded-circle object-fit-cover"
                                style={{ marginRight: '10px' }}
                            />
                            <div>
                                <div className="fw-medium">{category.first_name}</div>
                                <div className="font-size-12">{category.email}</div>
                                <div className="font-size-12">{category.phone}</div>
                                {companyName && (
                                    <div className="font-size-12 text-muted">
                                        <i className="bx bx-building me-1"></i>
                                        {companyName}
                                    </div>
                                )}
                                {/* <div className="font-size-12">{date}</div> */}
                            </div>
                        </div>
                    );
                },
            },
            {
                header: 'Domains',
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => {
                    const domains = row.original.domains_names || [];
                    const bookkeepingTools = row.original.bookkeeping_tools || [];
                    const taxTools = row.original.tax_tools || [];
                    
                    return (
                        <div className="fw-medium text-capitalize">
                            {domains.map((domain: string, index: number) => {
                                const isBookkeeping = domain.toLowerCase().includes('bookkeeping');
                                const isTax = domain.toLowerCase().includes('tax');
                                const hasTools = (isBookkeeping && bookkeepingTools.length > 0) || (isTax && taxTools.length > 0);
                                const toolsList = isBookkeeping ? bookkeepingTools : (isTax ? taxTools : []);
                                const tooltipId = `tools-tooltip-${row.original.id}-${index}`;
                                
                                return (
                                    <span key={index}>
                                        {domain}
                                        {hasTools && (
                                            <>
                                                <i 
                                                    id={tooltipId}
                                                    className="bx bx-info-circle ms-1 text-primary" 
                                                    style={{ cursor: 'pointer' }}
                                                />
                                                <UncontrolledTooltip placement="top" target={tooltipId}>
                                                    {toolsList.join(', ')}
                                                </UncontrolledTooltip>
                                            </>
                                        )}
                                        {index < domains.length - 1 && ', '}
                                    </span>
                                );
                            })}
                        </div>
                    );
                },
            },
            {
                header: 'Status',
                accessorFn: (row: any) => (row?.user?.is_active ? "Active" : "Inactive"),
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }: any) => {
                    const isActive = row.original.user?.is_active;
                    const id = row.original.id;
                    return (
                    <div className="d-flex align-items-center gap-2">
                        <div className={`fw-medium font-size-12 ${isActive ? 'text-success' : 'text-danger'}`}>
                            {isActive ? 'Active' : 'Inactive'}
                        </div>
                        <div className="form-check form-switch m-0">
                        <input type="checkbox" color="success"  className="form-check-input" id="customSwitchsizesm" checked={isActive}
                            onChange={() => handleToggle(id)}/>
                        {/* <input className="form-check-input" type="checkbox" role="switch" checked={isActive}
                            onChange={() => handleToggle(id)}/> */}
                    </div>
                    </div>
                    );
                },
            },
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: false,
                cell: ( { row })  => (
                    <div className="d-flex gap-2">
                        <button className="btn btn-info btn-sm" title="Click to View" onClick={() => {viewPartner(row.original);}}>
                            <i className="bx bx-show me-1"></i>
                            View
                        </button>
                        <button className="btn btn-dark btn-sm" title="Click to Edit" onClick={() => {editPartner(row.original.id);}}>
                            <i className="bx bx-pencil me-1"></i>
                            Edit
                        </button>
                        <button className="btn btn-danger btn-sm" title="Click to Delete" onClick={() => {deletePartner(row.original.id);}}>
                            <i className="bx bxs-trash-alt me-1"></i>
                            Delete
                        </button>
                    </div>
                ),
            }
        ],
        []
    );

    // const staticData = [
    //     {
    //         id: 1,
    //         category: {
    //             first_name: "John Elia",
    //             email: "john@example.com",
    //             phone: "+1 234 567 8901",
    //             profile_pic: "",
    //             is_active: true
    //         },
    //         cstpack: {
    //             plat_pack: { name: "Premium Plan", price: 99 },
    //             created_at: "2025-01-01T10:00:00Z",
    //             payment_status: "paid"
    //         },
    //         admin_verified: "unverified"
    //     },
    //     {
    //         id: 2,
    //         category: {
    //             first_name: "deepak",
    //             email: "deepak@example.com",
    //             phone: "+1 234 567 8901",
    //             profile_pic: "",
    //             is_active: true
    //         },
    //         cstpack: {
    //             plat_pack: { name: "Premium Plan", price: 99 },
    //             created_at: "2025-01-01T10:00:00Z",
    //             payment_status: "paid"
    //         },
    //         admin_verified: "unverified"
    //     }
    // ];

    
    const [formValues, setFormValues] = useState({
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        image: null,
        company_name: '',
    });

     const validateEmail = (email: string) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };
    
    const validatePhone = (phone: string) => {
      const phoneRegex = /^\+?[0-9]{1,3}?[0-9]{9}$/; // Allows country code + 10 digits
      return phoneRegex.test(phone);
    };


    
    const [error , setErrors] = useState({firstname : '',lastname : '',email : '',phone 
        : '',selectedDomains : ''})

    const add_partner_data = async () => {
        
        console.log('selectedExpert-----',formValues);
        setIsAdding(true);


        const newErrors : any = {};
        if(!formValues.firstname) newErrors.firstname = "First name is required!"
        if(!formValues.lastname) newErrors.lastname = "Last name is required!"
        if(!formValues.phone) {newErrors.phone = "Phone number is required!"}
        else if(!validatePhone(formValues.phone)) {
            newErrors.phone = "Enter a valid phone number!";
        }
        if(!formValues.email) {newErrors.email = "Email is required!!"}
        else if(!validateEmail(formValues.email)) {
            newErrors.email = "Invalid email format!";
        }
        if (!selectedDomains || selectedDomains.length === 0) {
        newErrors.selectedDomains = "Please select at least one domain!";
        }


        if(Object.keys(newErrors).length > 0){
            setErrors(newErrors)
            setIsAdding(false);
            return
        }
        
        const formData = new FormData();
        formData.append("firstname", formValues.firstname);
        formData.append("lastname", formValues.lastname);
        formData.append("email", formValues.email);
        formData.append("phone", formValues.phone);
        if (formValues.company_name) {
            formData.append("company_name", formValues.company_name);
        }
        selectedDomains.forEach(domainId => {
        formData.append('domains', domainId); 
        });

        // Always add bookkeeping_tools (even if empty array) so backend can clear it if needed
        formData.append('bookkeeping_tools', JSON.stringify(selectedBookkeepingTools));
        // Always add tax_tools (even if empty array) so backend can clear it if needed
        formData.append('tax_tools', JSON.stringify(selectedTaxTools));

        if (selectedPartnerId) {
            formData.append("partner_id", selectedPartnerId.toString());
            formData.append("action", "edit_partner");

        }
        
        if (selectedImage) {
            console.log('image in ',selectedImage)
            if (typeof selectedImage=== 'string' && selectedImage.startsWith('data:image')) {
                const response = await fetch(selectedImage);
                const blob = await response.blob();
                const file = new File([blob], 'profile.jpg', { type: blob.type });
                
                formData.append('profile_pic', file);
            } 
            else {
                formData.append('profile_pic', selectedImage);
            }
        }
            
        console.log('get data of add_partner_data',formData)
        
        try {
            setshowloader(true)
            const response = await axios.post(`${baseUrl}/accounts/get_add_partner`,formData,{headers: { 'Content-Type': 'multipart/form-data' }});
            console.log('data__fetch_partnerlisting',response)
            if (response.status === 'CREATE_PARTNER') {
                // setPartnerData(response.partner_list);
                
                fetch_partnerlisting();
                setmodal_center(false);
                setAlertMsgg({ open: true, content: "Partner created successfully", type: "success" });
                setSelectedImage(null);
                setFormValues({firstname: "",lastname: "",email: "",phone: "",image: null, company_name: ""});
                setSelectedDomains([]);
                setSelectedBookkeepingTools([]);
                setSelectedTaxTools([]);
                
                setTimeout(()=> {
                    setAlertMsgg((prev) => ({ ...prev, open: false, content: "", type: "" }));
                },4000)
                setIsAdding(false);
                // fetch_partnerlisting();
                setshowloader(false)
                
            }
            else{setshowloader(false)}
        } catch (error:any) {
            setIsAdding(false);
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false)
        }
    };

   

    const fetch_partnerlisting = async () => {
        try {
            setshowloader(true)
            const response = await axios.get(`${baseUrl}/accounts/get_add_partner`,{});
            console.log('data__fetch_partnerlisting',response)
            if (response.status === 'GET_PARTNER') {
                setPartnerData(response.partner_list);
                setshowloader(false)
                const dom_data = response.all_domain.map((item:any) => ({
                    id      : item.id,
                    name    : item.name
                }))

                setalldomaindata(dom_data)

            }
            else { setshowloader(false) }
            
        } catch (error:any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false)
        }
    };



    const edit_delete_partner = async () =>{
        console.log('selectedExpert-----',formValues);

    const newErrors : any = {};
    if(!formValues.firstname) newErrors.firstname = "First name is required!"
    if(!formValues.lastname) newErrors.lastname = "Last name is required!"
    if(!formValues.phone) {newErrors.phone = "Phone Number is required!"}
    else if(!validatePhone(formValues.phone)) {
        newErrors.phone = "Enter a valid phone number!";
    }
    if(!formValues.email) {newErrors.email = "Email is required!"}
    else if(!validateEmail(formValues.email)) {
        newErrors.email = "Invalid email format!";
    }
    if (!selectedDomains || selectedDomains.length === 0) {
    newErrors.selectedDomains = "Please select at least one domain!";
    }


    if(Object.keys(newErrors).length > 0){
        setErrors(newErrors)
        setIsAdding(false);
        return
    }

        const formData = new FormData();
        formData.append("firstname", formValues.firstname);
        formData.append("lastname", formValues.lastname);
        formData.append("email", formValues.email);
        formData.append("phone", formValues.phone);
        if (formValues.company_name) {
            formData.append("company_name", formValues.company_name);
        }

        selectedDomains.forEach(domainId => {
        formData.append("domains", domainId); 
    });

        // Always add bookkeeping_tools (even if empty array) so backend can clear it if needed
        formData.append('bookkeeping_tools', JSON.stringify(selectedBookkeepingTools));
        // Always add tax_tools (even if empty array) so backend can clear it if needed
        formData.append('tax_tools', JSON.stringify(selectedTaxTools));

        console.log("domainId--",selectedDomains)
        if (selectedPartnerId) {
            formData.append("partner_id", selectedPartnerId.toString());
            formData.append("action", "edit_partner");

        }
        
        if (selectedImage) {
            console.log('image in ',selectedImage)
            if (typeof selectedImage=== 'string' && selectedImage.startsWith('data:image')) {
                const response = await fetch(selectedImage);
                const blob = await response.blob();
                const file = new File([blob], 'profile.jpg', { type: blob.type });
                
                formData.append('profile_pic', file);
            } 
            else {
                formData.append('profile_pic', selectedImage);
            }
        }

        console.log('get data of add_partner_data',formData)

        try {
            setshowloader(true)
            const response = await axios.post(`${baseUrl}/accounts/edit_delete_partner`,formData,{headers: { 'Content-Type': 'multipart/form-data' }});
            console.log('data__fetch_partnerlisting',response)
            if (response.status === "EDIT_PARTNER") {
                fetch_partnerlisting();
                setAlertMsgg({ open: true, content: "Partner edit successfully", type: "success" });
                setmodal_edit_partner(false);
                setSelectedImage(null);
                setFormValues({firstname: "",lastname: "",email: "",phone: "",image: null, company_name: ""});
                setSelectedDomains([]);
                setSelectedBookkeepingTools([]);
                setSelectedTaxTools([]);

                setTimeout(()=> {
                    setAlertMsgg((prev) => ({ ...prev, open: false, content: "", type: "" }));
                },4000)
                // setPartnerData(response.partner_list);
                // fetch_partnerlisting();
                setshowloader(false)
            }
            else{setshowloader(false)}
            
        } catch (error:any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false)
        }

        
    };

    const delete_Partner = async (partner_id:any) =>{
        const formData = new FormData();
        formData.append("action", "delete_partner");
        formData.append("partner_id", partner_id);
        try {
            setshowloader(true)
            const response = await axios.post(`${baseUrl}/accounts/edit_delete_partner`,formData);
            if (response.status === "DELETE_PARTNER") {
                fetch_partnerlisting();
                setAlertMsgg({ open: true, content: "Partner delete successfully", type: "success" });
                setmodal_delete_partner(false);
                setSelectedImage(null);
                setFormValues({firstname: "",lastname: "",email: "",phone: "",image: null, company_name: ""});

                setTimeout(()=> {
                    setAlertMsgg((prev) => ({ ...prev, open: false, content: "", type: "" }));
                },4000)
                setshowloader(false)
            }
            else{setshowloader(false)}
            
        } catch (error:any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false)
        }

    }

    useEffect(() => {
        fetch_partnerlisting();

        subscribeToTokenRefresh(() => {
            console.log("🔁 Token refreshed. Re-fetching experts...");
            fetch_partnerlisting();
        });
    },[]);
    useEffect(() => {console.log('Updated partnerData:', partnerData);}, [partnerData]);
    
    // Debug: Monitor modal state
    useEffect(() => {
        console.log('modal_view_partner state changed to:', modal_view_partner);
        console.log('selectedPartnerForView:', selectedPartnerForView);
    }, [modal_view_partner, selectedPartnerForView]);
    
    useEffect(() => {
    if (selectedPartnerId !== null && partnerData.length > 0) {
        const selectedPartner = partnerData.find(
        (partner) => partner.id === selectedPartnerId
        );

        // console.log("💥 Partner loaded:", selectedPartner);

        if (selectedPartner) {
        const user = selectedPartner.user;
        setFormValues({
            firstname: user.first_name || '',
            lastname: user.last_name || '',
            email: user.email || '',
            phone: user.phone || '',
            image: user.profile_pic || null,
            company_name: selectedPartner.company_name || '',
        });
        setSelectedImage(user.profile_pic || null);
        const domainIds = selectedPartner.domains.map((id: number) => id.toString());
            setSelectedDomains(domainIds);
        // Load bookkeeping_tools if available
        if (selectedPartner.bookkeeping_tools && Array.isArray(selectedPartner.bookkeeping_tools)) {
            setSelectedBookkeepingTools(selectedPartner.bookkeeping_tools);
        } else {
            setSelectedBookkeepingTools([]);
        }
        // Load tax_tools if available
        if (selectedPartner.tax_tools && Array.isArray(selectedPartner.tax_tools)) {
            setSelectedTaxTools(selectedPartner.tax_tools);
        } else {
            setSelectedTaxTools([]);
        }
        }
    }
    }, [selectedPartnerId, partnerData]);

    document.title = "Partners | BizServe";

    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumbs title="Admin" breadcrumbItem="Partners" />
                {alertMsgg.open && (
                <Alert 
                    color={alertMsgg.type === "success" ? "success" : "danger"} 
                    toggle={handleAlertMsggClose}
                    fade={true}
                    style={{ fontWeight: "bold" }}
                > {alertMsgg.content}
                </Alert>
                )}

                {/* <Breadcrumbs title="Domains " breadcrumbItem="Domains" /> */}

                <div className="loaderContainer" hidden={!showloader}>
                    <div className="spinner">
                        <div></div>   
                        <div></div>    
                        <div></div>    
                        <div></div>    
                        <div></div>    
                        <div></div>    
                        <div></div>    
                        <div></div>    
                        <div></div>    
                        <div></div>    
                    </div>
                </div>
                <Row>
                    <Col md={12} className="d-flex justify-content-end align-items-center mb-3">
                        <button
                        type="button"
                        className="btn btn-primary "
                        onClick={() => {
                            add_partner();
                        }}
                        >
                        Add Partner
                        </button>
                    </Col>
                    <Col md={12}>
                        <Card className="rounded-4 border">
                            <CardBody>
                                <TableContainer
                                    columns={columns}
                                    data={partnerData || []}
                                    isGlobalFilter={true}
                                    isPagination={true}
                                    SearchPlaceholder="Search By Name..."
                                    pagination="pagination"
                                    paginationWrapper='dataTables_paginate paging_simple_numbers'
                                    tableClass="table-bordered dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Modal
                    isOpen={modal_center}
                    toggle={() => {
                    add_partner();
                    }}
                    size="lg"
                    backdrop={'static'}
                    centered
                >
                    <ModalHeader toggle={() => {add_partner()}}>
                        <div className="modal-title mt-0 font-size-16 text-dark">Add Partner</div>
                    </ModalHeader>
                    <div className="modal-body">
                        <Row>
                        <Col lg={12}>
                            <div className="mb-3 border-bottom pb-3 text-center">
                            <div className="mb-3">
                                <div className="text-center">
                                <div className="position-relative bottom-0 end-0">
                                    <Label htmlFor="project-image-input" className="mb-0 position-relative" id="projectImageInput">
                                    <div className="avatar-xs imageChangeFloat">
                                        <div className="avatar-title bg-light border rounded-circle text-muted cursor-pointer shadow font-size-16">
                                        <i className="bx bxs-image-alt"></i>
                                        </div>
                                    </div>
                                    <div className="avatar-lg">
                                        <div className="avatar-title bg-light rounded-circle">
                                        <img src={selectedImage || defaultUserImg} id="projectlogo-img" alt="" className="avatar-md  rounded-circle object-fit-cover" />
                                        </div>
                                    </div>
                                    </Label>
                                    <input className="form-control d-none" id="project-image-input" type="file" accept="image/png, image/gif, image/jpeg" onChange={handleImageChangeo} />
                                </div>
                                </div>
                                </div>
                            <Label className="form-label ">Partner Image</Label>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="mb-3">
                            <label className="form-label">First Name<span className="text-danger px-1">*</span></label>
                            <input
                                className={`form-control ${error.firstname ? 'is-invalid' : ''}`}
                                type="text"
                                placeholder="First Name"
                                value={formValues.firstname}
                                onChange={(e) => {setFormValues({ ...formValues, firstname: e.target.value })
                            setErrors((prev) => ({ ...prev,firstname: '' }));
                        }}
                            />
                            {error.firstname && <div className="invalid-feedback">{error.firstname}</div>}
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="mb-3">
                            <label className="form-label">Last Name<span className="text-danger px-1">*</span></label>
                            <input
                                className={`form-control ${error.lastname ? 'is-invalid' : ''}`}
                                type="text"
                                placeholder="Last Name"
                                value={formValues.lastname}
                                onChange={(e) => {setFormValues({ ...formValues, lastname: e.target.value })
                                setErrors((prev) => ({ ...prev,lastname : ''}));
                            }}  
                            />
                            {error.lastname && <div className="invalid-feedback">{error.lastname}</div>}
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="mb-3">
                            <label className="form-label">Email<span className="text-danger px-1">*</span></label>
                            <input
                                className={`form-control ${error.email ? 'is-invalid' : ''}`}
                                type="email"
                                placeholder="Enter Email"
                                value={formValues.email}
                                onChange={(e) => {setFormValues({ ...formValues, email: e.target.value });
                                setErrors((prev) => ({ ...prev,email : ''}));
                            }}
                            />
                            {error.email && <div className="invalid-feedback">{error.email}</div>}
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="mb-3" >
                            <label className="form-label">Phone<span className="text-danger px-1">*</span></label>
                            <input
                                className={`form-control ${error.phone ? 'is-invalid' : ''}`}
                                type="text"
                                placeholder="Enter Phone number"
                                value={formValues.phone}
                                onChange={(e) => {setFormValues({ ...formValues, phone: e.target.value });
                                setErrors((prev) => ({ ...prev,phone : ''}));
                            }}   
                            />
                            {error.phone && <div className="invalid-feedback">{error.phone}</div>}
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="mb-3">
                            <label className="form-label">Company Name</label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Enter Company Name (Optional)"
                                value={formValues.company_name}
                                onChange={(e) => {setFormValues({ ...formValues, company_name: e.target.value })}}
                            />
                            </div>
                        </Col>
                        <Col lg={12}>
                        <div className="mb-3">
                            <label className="form-label">Select Domains<span className="text-danger px-1">*</span></label>
                            <Select isMulti name="domains" options={all_domain_data.map(domain => ({
                                value: domain.id.toString(),label: domain.name}))}
                            value={selectedDomains.map(id => {const domain = all_domain_data.find(d => d.id.toString() === id);
                                return domain ? { value: domain.id.toString(), label: domain.name } : null;
                            }).filter(Boolean)}
                            onChange={(selectedOptions) => {const ids = Array.isArray(selectedOptions)
                                ? selectedOptions.filter((option): option is { value: string } => option !== null && typeof option === 'object' && 'value' in option).map(option => option.value): [];
                            setSelectedDomains(ids);
                            setErrors(prev => ({ ...prev, selectedDomains: '' }));
                            }}
                            // className="select2-selection"
                            className={`select2-selection ${error.selectedDomains ? 'is-invalid is-invalid-custom' : ''}`}
                            placeholder="Select domains..."
                            />
                            {/* {error.selectedDomains && (
                            <small className="text-danger">{error.selectedDomains}</small>)} */}
                            {error.selectedDomains && <div className="invalid-feedback">{error.selectedDomains}</div>}
                        </div>
                        </Col>

                        {/* Bookkeeping Tools - Show only if bookkeeping domain is selected */}
                        {isBookkeepingDomainSelected() && (
                        <Col lg={12}>
                            <div className="mb-3">
                                <label className="form-label">Bookkeeping Tools</label>
                                <Select
                                    isMulti
                                    name="bookkeeping_tools"
                                    options={bookkeepingToolsOptions}
                                    value={selectedBookkeepingTools.map(tool => ({
                                        value: tool,
                                        label: tool
                                    }))}
                                    onChange={(selectedOptions) => {
                                        const tools = Array.isArray(selectedOptions)
                                            ? selectedOptions.map(option => option.value)
                                            : [];
                                        setSelectedBookkeepingTools(tools);
                                    }}
                                    className="select2-selection"
                                    placeholder="Select bookkeeping tools..."
                                />
                            </div>
                        </Col>
                        )}

                        {/* Tax Tools - Show only if tax domain is selected */}
                        {isTaxDomainSelected() && (
                        <Col lg={12}>
                            <div className="mb-3">
                                <label className="form-label">Tax Tools</label>
                                <Select
                                    isMulti
                                    name="tax_tools"
                                    options={taxToolsOptions}
                                    value={selectedTaxTools.map(tool => ({
                                        value: tool,
                                        label: tool
                                    }))}
                                    onChange={(selectedOptions) => {
                                        const tools = Array.isArray(selectedOptions)
                                            ? selectedOptions.map(option => option.value)
                                            : [];
                                        setSelectedTaxTools(tools);
                                    }}
                                    className="select2-selection"
                                    placeholder="Select tax tools..."
                                />
                            </div>
                        </Col>
                        )}

                        <Col lg={12}>
                            <div className="d-flex justify-content-end">
                                <button
                                className="btn btn-primary mb-3"
                                onClick={add_partner_data}
                                disabled={isAdding} // disable during request
                                >
                                {isAdding ? "Adding..." : "Add Partner"}
                                </button>
                            </div>
                        </Col>

                        </Row>
                    </div>
                </Modal>

                <Modal
                    isOpen={modal_standard_edit_partner}
                    toggle={() => {
                    editPartner();
                    }}
                    size="lg"
                    backdrop={'static'}
                    centered
                >
                    <ModalHeader toggle={() => {
                    closeeditPartner();
                    }}>
                    <div className="modal-title mt-0 font-size-16 text-dark">Edit Partner</div>
                    </ModalHeader>
                    <div className="modal-body">
                    <Row>
                    <Col lg={12}>
                        <div className="mb-3 border-bottom pb-3 text-center">
                        

                        <div className="mb-3">

                            <div className="text-center">
                            <div className="position-relative bottom-0 end-0">
                                <Label htmlFor="project-image-input" className="mb-0 position-relative" id="projectImageInput">
                                <div className="avatar-xs imageChangeFloat">
                                    <div className="avatar-title bg-light border rounded-circle text-muted cursor-pointer shadow font-size-16">
                                    <i className="bx bxs-image-alt"></i>
                                    </div>
                                </div>
                                <div className="avatar-lg">
                                    <div className="avatar-title bg-light rounded-circle">
                                    <img src={selectedImage || defaultUserImg} id="projectlogo-img" alt="" className="avatar-md  rounded-circle object-fit-cover" />
                                    </div>
                                </div>
                                </Label>
                                <input className="form-control d-none" id="project-image-input" type="file" accept="image/png, image/gif, image/jpeg" onChange={handleImageChangeo} />
                            </div>
                            </div>
                            </div>
                        <Label className="form-label ">Partner Image</Label>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="mb-3">
                        <label className="form-label">First Name<span className="text-danger px-1">*</span></label>
                        <input
                            className={`form-control ${error.firstname ? 'is-invalid' : ''}`}
                            type="text"
                            placeholder="First Name"
                            value={formValues.firstname}
                            onChange={(e) => {setFormValues({ ...formValues, firstname: e.target.value });
                            setErrors((prev) => ({ ...prev,firstname: ''}));
                        }} 
                        />
                        {error.firstname && <div className="invalid-feedback">{error.firstname}</div>}
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="mb-3">
                        <label className="form-label">Last Name<span className="text-danger px-1">*</span></label>
                        <input
                            className={`form-control ${error.lastname ? 'is-invalid' : ''}`}
                            type="text"
                            placeholder="Last Name"
                            value={formValues.lastname}
                            onChange={(e) => {setFormValues({ ...formValues, lastname: e.target.value });
                            setErrors((prev) => ({ ...prev,lastname: ''}));
                        }}
                        />
                        {error.lastname && <div className="invalid-feedback">{error.lastname}</div>}
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="mb-3">
                        <label className="form-label">Email<span className="text-danger px-1">*</span></label>
                        <input
                            className={`form-control ${error.email ? 'is-invalid' : ''}`}
                            type="email"
                            placeholder="Enter Email"
                            value={formValues.email}
                            onChange={(e) => {setFormValues({ ...formValues, email: e.target.value })
                            setErrors((prev) => ({ ...prev,email: ''}));
                            }}
                        />
                        {error.email && <div className="invalid-feedback">{error.email}</div>}
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="mb-3" >
                        <label className="form-label">Phone<span className="text-danger px-1">*</span></label>
                        <input
                            className={`form-control ${error.phone ? 'is-invalid' : ''}`}
                            type="text"
                            placeholder="Enter Phone number"
                            value={formValues.phone}
                            onChange={(e) => {setFormValues({ ...formValues, phone: e.target.value });
                            setErrors((prev) => ({ ...prev,phone: ''}));
                            }}
                        />
                        {error.phone && <div className="invalid-feedback">{error.phone}</div>}
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="mb-3">
                        <label className="form-label">Company Name</label>
                        <input
                            className="form-control"
                            type="text"
                            placeholder="Enter Company Name (Optional)"
                            value={formValues.company_name}
                            onChange={(e) => {setFormValues({ ...formValues, company_name: e.target.value })}}
                        />
                        </div>
                    </Col>

            
                    <Col lg={12}>
                    <div className="mb-3">
                        <label className="form-label">Domains<span className="text-danger px-1">*</span></label>
                        <Select
                            isMulti
                            name="domains"
                            options={all_domain_data.map(domain => ({value: domain.id.toString(),label: domain.name}))}
                            value={selectedDomains.map(id => {
                                const domain = all_domain_data.find(d => d.id.toString() === id);
                                return domain ? { value: domain.id.toString(), label: domain.name } : null;
                            }).filter(Boolean)}
                            onChange={(selectedOptions) => {
                                const ids = Array.isArray(selectedOptions)? selectedOptions.filter((option): option is { value: string } =>
                                            option !== null && typeof option === 'object' && 'value' in option)
                                        .map(option => option.value): [];
                                setSelectedDomains(ids);
                                setErrors(prev => ({ ...prev, selectedDomains: '' }));
                            }}
                            // className="select2-selection"
                            className={`select2-selection ${error.selectedDomains ? 'is-invalid is-invalid-custom' : ''}`}
                            placeholder="Select domains..."
                        />
                        {/* {error.selectedDomains && <small className="text-danger">{error.selectedDomains}</small>} */}
                        {error.selectedDomains && <div className="invalid-feedback">{error.selectedDomains}</div>}
                    </div>
                </Col>

                    {/* Bookkeeping Tools - Show only if bookkeeping domain is selected */}
                    {isBookkeepingDomainSelected() && (
                    <Col lg={12}>
                        <div className="mb-3">
                            <label className="form-label">Bookkeeping Tools</label>
                            <Select
                                isMulti
                                name="bookkeeping_tools"
                                options={bookkeepingToolsOptions}
                                value={selectedBookkeepingTools.map(tool => ({
                                    value: tool,
                                    label: tool
                                }))}
                                onChange={(selectedOptions) => {
                                    const tools = Array.isArray(selectedOptions)
                                        ? selectedOptions.map(option => option.value)
                                        : [];
                                    setSelectedBookkeepingTools(tools);
                                }}
                                className="select2-selection"
                                placeholder="Select bookkeeping tools..."
                            />
                        </div>
                    </Col>
                    )}

                    {/* Tax Tools - Show only if tax domain is selected */}
                    {isTaxDomainSelected() && (
                    <Col lg={12}>
                        <div className="mb-3">
                            <label className="form-label">Tax Tools</label>
                            <Select
                                isMulti
                                name="tax_tools"
                                options={taxToolsOptions}
                                value={selectedTaxTools.map(tool => ({
                                    value: tool,
                                    label: tool
                                }))}
                                onChange={(selectedOptions) => {
                                    const tools = Array.isArray(selectedOptions)
                                        ? selectedOptions.map(option => option.value)
                                        : [];
                                    setSelectedTaxTools(tools);
                                }}
                                className="select2-selection"
                                placeholder="Select tax tools..."
                            />
                        </div>
                    </Col>
                    )}
                    
                    <Col lg={12}>
                        <div className="d-flex justify-content-end">
                        {/* <button className="btn btn-primary mb-3">Edit Partner</button> */}
                        <button className="btn btn-primary mb-3" onClick={()=> edit_delete_partner()}>Edit Partner</button>
                        </div>
                    </Col>
                    </Row>
                    </div>
                </Modal>    
                
                <Modal
                    isOpen={modal_standard_delete_partner}
                    toggle={() => {deletePartner()}}
                centered
                className="rounded-4"
                >
                <ModalHeader className="py-3 px-4" toggle={() => {deletePartner()}}>
                    <div className="modal-title mt-0 font-size-16 text-dark">
                    Delete Partner
                    </div>
                </ModalHeader>

                <div className="modal-body">
                    <p>Are you sure you want to delete this partner?</p>
                </div>

                <div className="modal-footer">
                    <button 
                    type="button" 
                    className="btn btn-sm btn-soft-dark" 
                    onClick={() => {deletePartner()}}
                    >
                    Cancel
                    </button>
                    <button 
                    type="button" 
                    className="btn btn-sm btn-danger" 
                    onClick={() => {
                        console.log("Deleting ID:", selectedPartnerId);
                        delete_Partner(selectedPartnerId)
                    }}
                    >
                    Delete
                    </button>
                </div>
                </Modal>

                {/* View Partner Modal */}
                <Modal
                    isOpen={modal_view_partner}
                    toggle={() => {closeViewPartner()}}
                    size="lg"
                    backdrop={'static'}
                    centered
                    className="rounded-4"
                    onOpened={() => console.log("Modal opened")}
                >
                    <ModalHeader className="py-3 px-4" toggle={() => {closeViewPartner()}}>
                        <div className="modal-title mt-0 font-size-16 text-dark">
                            Partner Details
                        </div>
                    </ModalHeader>
                    <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                        {selectedPartnerForView ? (
                            <>
                                {/* Partner Card - Profile Picture and Details */}
                                <Card className="mb-4">
                                    <CardBody>
                                        <Row className="align-items-center">
                                            {/* Profile Picture */}
                                            <Col lg={3} className="text-center mb-3 mb-lg-0">
                                                <img
                                                    src={selectedPartnerForView.user?.profile_pic || defaultUserImg}
                                                    alt="Partner"
                                                    width="120"
                                                    height="120"
                                                    className="rounded-circle object-fit-cover border"
                                                />
                                            </Col>
                                            
                                            {/* Partner Details */}
                                            <Col lg={9}>
                                                <div className="mb-3">
                                                    <h5 className="mb-2">{selectedPartnerForView.user?.first_name} {selectedPartnerForView.user?.last_name}</h5>
                                                    
                                                    {/* Email */}
                                                    <div className="mb-2">
                                                        <div className="fw-medium">
                                                            <i className="bx bx-envelope me-2 text-muted"></i>
                                                            {selectedPartnerForView.user?.email || 'N/A'}
                                                        </div>
                                                    </div>
                                                    
                                                    {/* Phone */}
                                                    <div className="mb-2">
                                                        <div className="fw-medium">
                                                            <i className="bx bx-phone me-2 text-muted"></i>
                                                            {selectedPartnerForView.user?.phone || 'N/A'}
                                                        </div>
                                                    </div>
                                                    
                                                    {/* Domains */}
                                                    <div className="mb-2">
                                                        <div className="d-flex flex-wrap gap-2 align-items-center">
                                                            <i className="bx bx-category me-1 text-muted"></i>
                                                            {selectedPartnerForView.domains_names && selectedPartnerForView.domains_names.length > 0 ? (
                                                                selectedPartnerForView.domains_names.map((domain: string, index: number) => (
                                                                    <span key={index} className="badge bg-primary">
                                                                        {domain}
                                                                    </span>
                                                                ))
                                                            ) : (
                                                                <span className="text-muted">No domains assigned</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    
                                                    {/* Tools */}
                                                    {(selectedPartnerForView.bookkeeping_tools && selectedPartnerForView.bookkeeping_tools.length > 0) || 
                                                     (selectedPartnerForView.tax_tools && selectedPartnerForView.tax_tools.length > 0) ? (
                                                        <div className="d-flex flex-wrap gap-2 align-items-center">
                                                            {(selectedPartnerForView.bookkeeping_tools && selectedPartnerForView.bookkeeping_tools.length > 0) && (
                                                                selectedPartnerForView.bookkeeping_tools.map((tool: string, index: number) => (
                                                                    <span key={index} className="badge bg-info">
                                                                        {tool}
                                                                    </span>
                                                                ))
                                                            )}
                                                            {(selectedPartnerForView.tax_tools && selectedPartnerForView.tax_tools.length > 0) && (
                                                                selectedPartnerForView.tax_tools.map((tool: string, index: number) => (
                                                                    <span key={index} className="badge bg-warning text-dark">
                                                                        {tool}
                                                                    </span>
                                                                ))
                                                            )}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>

                                {/* Tabs Navigation */}
                                <Nav tabs className="nav-tabs-custom mb-3">
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({ active: activeViewTab === "1" })}
                                            onClick={() => { setActiveViewTab("1"); }}
                                        >
                                            Company Information
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({ active: activeViewTab === "2" })}
                                            onClick={() => { setActiveViewTab("2"); }}
                                        >
                                            Pre Sale Contact Preferences
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({ active: activeViewTab === "3" })}
                                            onClick={() => { setActiveViewTab("3"); }}
                                        >
                                            Post Sale Contact Preferences
                                        </NavLink>
                                    </NavItem>
                                </Nav>

                                <TabContent activeTab={activeViewTab}>
                                    {/* Company Information Tab */}
                                    <TabPane tabId="1">
                                        <Row>
                                            {/* Company Information - Name and Description First */}
                                            {selectedPartnerForView.company_name && (
                                                <Col lg={12} className="mb-3">
                                                    <div className="border-bottom pb-2">
                                                        <div className="fw-medium">{selectedPartnerForView.company_name}</div>
                                                        <small className="text-muted">Company Name</small>
                                                    </div>
                                                </Col>
                                            )}
                                            
                                            {selectedPartnerForView.company_description && (
                                                <Col lg={12} className="mb-3">
                                                    <div className="border-bottom pb-2">
                                                        <div className="fw-medium">{selectedPartnerForView.company_description}</div>
                                                        <small className="text-muted">Company Description</small>
                                                    </div>
                                                </Col>
                                            )}

                                            {/* Address */}
                                            {selectedPartnerForView.address_line1 && (
                                                <Col lg={12} className="mb-3">
                                                    <div className="border-bottom pb-2">
                                                        <div className="fw-medium">{selectedPartnerForView.address_line1}</div>
                                                        <small className="text-muted">Address Line 1</small>
                                                    </div>
                                                </Col>
                                            )}
                                            
                                            {selectedPartnerForView.address_line2 && (
                                                <Col lg={12} className="mb-3">
                                                    <div className="border-bottom pb-2">
                                                        <div className="fw-medium">{selectedPartnerForView.address_line2}</div>
                                                        <small className="text-muted">Address Line 2</small>
                                                    </div>
                                                </Col>
                                            )}
                                            
                                            {(selectedPartnerForView.city || selectedPartnerForView.state || selectedPartnerForView.zipcode || selectedPartnerForView.country) && (
                                                <Col lg={12} className="mb-3">
                                                    <div className="border-bottom pb-2">
                                                        <div className="fw-medium">
                                                            {[
                                                                selectedPartnerForView.city,
                                                                selectedPartnerForView.state,
                                                                selectedPartnerForView.zipcode,
                                                                selectedPartnerForView.country
                                                            ].filter(Boolean).join(', ') || 'N/A'}
                                                        </div>
                                                        <small className="text-muted">City, State, ZIP, Country</small>
                                                    </div>
                                                </Col>
                                            )}
                                            
                                            {selectedPartnerForView.industry && (
                                                <Col lg={6} className="mb-3">
                                                    <div className="border-bottom pb-2">
                                                        <div className="fw-medium">{selectedPartnerForView.industry}</div>
                                                        <small className="text-muted">Industry</small>
                                                    </div>
                                                </Col>
                                            )}
                                            
                                            {selectedPartnerForView.years_in_business && (
                                                <Col lg={6} className="mb-3">
                                                    <div className="border-bottom pb-2">
                                                        <div className="fw-medium">{selectedPartnerForView.years_in_business}</div>
                                                        <small className="text-muted">Years in Business</small>
                                                    </div>
                                                </Col>
                                            )}
                                            
                                            {selectedPartnerForView.number_of_employees && (
                                                <Col lg={6} className="mb-3">
                                                    <div className="border-bottom pb-2">
                                                        <div className="fw-medium">{selectedPartnerForView.number_of_employees}</div>
                                                        <small className="text-muted">Number of Employees</small>
                                                    </div>
                                                </Col>
                                            )}
                                            
                                            {selectedPartnerForView.company_size && (
                                                <Col lg={6} className="mb-3">
                                                    <div className="border-bottom pb-2">
                                                        <div className="fw-medium">{selectedPartnerForView.company_size}</div>
                                                        <small className="text-muted">Company Size</small>
                                                    </div>
                                                </Col>
                                            )}
                                            
                                            {selectedPartnerForView.service_areas && (
                                                <Col lg={12} className="mb-3">
                                                    <div className="border-bottom pb-2">
                                                        <div className="fw-medium">{selectedPartnerForView.service_areas}</div>
                                                        <small className="text-muted">Service Areas</small>
                                                    </div>
                                                </Col>
                                            )}
                                            
                                            {selectedPartnerForView.specializations && (
                                                <Col lg={12} className="mb-3">
                                                    <div className="border-bottom pb-2">
                                                        <div className="fw-medium">{selectedPartnerForView.specializations}</div>
                                                        <small className="text-muted">Specializations</small>
                                                    </div>
                                                </Col>
                                            )}

                                            {/* Website and Social Media */}
                                            {selectedPartnerForView.website && (
                                                <Col lg={12} className="mb-3">
                                                    <div className="border-bottom pb-2">
                                                        <div className="fw-medium">
                                                            <a href={selectedPartnerForView.website} target="_blank" rel="noopener noreferrer" className="text-primary">
                                                                {selectedPartnerForView.website} <i className="bx bx-link-external"></i>
                                                            </a>
                                                        </div>
                                                        <small className="text-muted">Website</small>
                                                    </div>
                                                </Col>
                                            )}
                                            
                                            {selectedPartnerForView.linkedin_url && (
                                                <Col lg={6} className="mb-3">
                                                    <div className="border-bottom pb-2">
                                                        <div className="fw-medium">
                                                            <a href={selectedPartnerForView.linkedin_url} target="_blank" rel="noopener noreferrer" className="text-primary">
                                                                View Profile <i className="bx bx-link-external"></i>
                                                            </a>
                                                        </div>
                                                        <small className="text-muted">LinkedIn</small>
                                                    </div>
                                                </Col>
                                            )}
                                            
                                            {selectedPartnerForView.facebook_url && (
                                                <Col lg={6} className="mb-3">
                                                    <div className="border-bottom pb-2">
                                                        <div className="fw-medium">
                                                            <a href={selectedPartnerForView.facebook_url} target="_blank" rel="noopener noreferrer" className="text-primary">
                                                                View Page <i className="bx bx-link-external"></i>
                                                            </a>
                                                        </div>
                                                        <small className="text-muted">Facebook</small>
                                                    </div>
                                                </Col>
                                            )}
                                            
                                            {selectedPartnerForView.x_url && (
                                                <Col lg={6} className="mb-3">
                                                    <div className="border-bottom pb-2">
                                                        <div className="fw-medium">
                                                            <a href={selectedPartnerForView.x_url} target="_blank" rel="noopener noreferrer" className="text-primary">
                                                                View Profile <i className="bx bx-link-external"></i>
                                                            </a>
                                                        </div>
                                                        <small className="text-muted">X (Twitter)</small>
                                                    </div>
                                                </Col>
                                            )}
                                            
                                            {selectedPartnerForView.instagram_url && (
                                                <Col lg={6} className="mb-3">
                                                    <div className="border-bottom pb-2">
                                                        <div className="fw-medium">
                                                            <a href={selectedPartnerForView.instagram_url} target="_blank" rel="noopener noreferrer" className="text-primary">
                                                                View Profile <i className="bx bx-link-external"></i>
                                                            </a>
                                                        </div>
                                                        <small className="text-muted">Instagram</small>
                                                    </div>
                                                </Col>
                                            )}
                                            
                                            {selectedPartnerForView.youtube_url && (
                                                <Col lg={6} className="mb-3">
                                                    <div className="border-bottom pb-2">
                                                        <div className="fw-medium">
                                                            <a href={selectedPartnerForView.youtube_url} target="_blank" rel="noopener noreferrer" className="text-primary">
                                                                View Channel <i className="bx bx-link-external"></i>
                                                            </a>
                                                        </div>
                                                        <small className="text-muted">YouTube</small>
                                                    </div>
                                                </Col>
                                            )}
                                        </Row>
                                    </TabPane>

                                    {/* Presale Tab */}
                                    <TabPane tabId="2">
                                        <Row>
                                            {selectedPartnerForView.communication_preference ? (
                                                <>
                                                    {selectedPartnerForView.communication_preference.bef_pur_email && (
                                                        <Col lg={6} className="mb-3">
                                                            <div className="border-bottom pb-2">
                                                                <div className="fw-medium">
                                                                    {selectedPartnerForView.communication_preference.bef_pur_email}
                                                                    {selectedPartnerForView.communication_preference.bef_pur_email_enabled && <span className="badge bg-success ms-2">Enabled</span>}
                                                                </div>
                                                                <small className="text-muted">Email</small>
                                                            </div>
                                                        </Col>
                                                    )}
                                                    
                                                    {selectedPartnerForView.communication_preference.bef_pur_phone && (
                                                        <Col lg={6} className="mb-3">
                                                            <div className="border-bottom pb-2">
                                                                <div className="fw-medium">
                                                                    {selectedPartnerForView.communication_preference.bef_pur_phone}
                                                                    {selectedPartnerForView.communication_preference.bef_pur_phone_enabled && <span className="badge bg-success ms-2">Enabled</span>}
                                                                </div>
                                                                <small className="text-muted">Phone</small>
                                                            </div>
                                                        </Col>
                                                    )}
                                                    
                                                    {selectedPartnerForView.communication_preference.bef_pur_whatsapp && (
                                                        <Col lg={6} className="mb-3">
                                                            <div className="border-bottom pb-2">
                                                                <div className="fw-medium">
                                                                    {selectedPartnerForView.communication_preference.bef_pur_whatsapp}
                                                                    {selectedPartnerForView.communication_preference.bef_pur_whatsapp_enabled && <span className="badge bg-success ms-2">Enabled</span>}
                                                                </div>
                                                                <small className="text-muted">WhatsApp</small>
                                                            </div>
                                                        </Col>
                                                    )}
                                                    
                                                    {selectedPartnerForView.communication_preference.bef_pur_calendly && (
                                                        <Col lg={6} className="mb-3">
                                                            <div className="border-bottom pb-2">
                                                                <div className="fw-medium">
                                                                    <a href={selectedPartnerForView.communication_preference.bef_pur_calendly} target="_blank" rel="noopener noreferrer" className="text-primary">
                                                                        Schedule Meeting <i className="bx bx-link-external"></i>
                                                                    </a>
                                                                    {selectedPartnerForView.communication_preference.bef_pur_calendly_enabled && <span className="badge bg-success ms-2">Enabled</span>}
                                                                </div>
                                                                <small className="text-muted">Calendly</small>
                                                            </div>
                                                        </Col>
                                                    )}
                                                    
                                                    {selectedPartnerForView.communication_preference.bef_pur_zoom && (
                                                        <Col lg={6} className="mb-3">
                                                            <div className="border-bottom pb-2">
                                                                <div className="fw-medium">
                                                                    <a href={selectedPartnerForView.communication_preference.bef_pur_zoom} target="_blank" rel="noopener noreferrer" className="text-primary">
                                                                        Join Meeting <i className="bx bx-link-external"></i>
                                                                    </a>
                                                                    {selectedPartnerForView.communication_preference.bef_pur_zoom_enabled && <span className="badge bg-success ms-2">Enabled</span>}
                                                                </div>
                                                                <small className="text-muted">Zoom</small>
                                                            </div>
                                                        </Col>
                                                    )}
                                                    
                                                    {selectedPartnerForView.communication_preference.bef_pur_teams && (
                                                        <Col lg={6} className="mb-3">
                                                            <div className="border-bottom pb-2">
                                                                <div className="fw-medium">
                                                                    <a href={selectedPartnerForView.communication_preference.bef_pur_teams} target="_blank" rel="noopener noreferrer" className="text-primary">
                                                                        Join Meeting <i className="bx bx-link-external"></i>
                                                                    </a>
                                                                    {selectedPartnerForView.communication_preference.bef_pur_teams_enabled && <span className="badge bg-success ms-2">Enabled</span>}
                                                                </div>
                                                                <small className="text-muted">Microsoft Teams</small>
                                                            </div>
                                                        </Col>
                                                    )}
                                                    
                                                    {selectedPartnerForView.communication_preference.bef_pur_notes && (
                                                        <Col lg={12} className="mb-3">
                                                            <div className="border-bottom pb-2">
                                                                <div className="fw-medium">{selectedPartnerForView.communication_preference.bef_pur_notes}</div>
                                                                <small className="text-muted">Notes</small>
                                                            </div>
                                                        </Col>
                                                    )}
                                                </>
                                            ) : (
                                                <Col lg={12}>
                                                    <div className="text-center text-muted py-4">No presale contact preferences set</div>
                                                </Col>
                                            )}
                                        </Row>
                                    </TabPane>

                                    {/* After Sale Tab */}
                                    <TabPane tabId="3">
                                        <Row>
                                            {selectedPartnerForView.communication_preference ? (
                                                <>
                                                    {selectedPartnerForView.communication_preference.aft_pur_email && (
                                                        <Col lg={6} className="mb-3">
                                                            <div className="border-bottom pb-2">
                                                                <div className="fw-medium">
                                                                    {selectedPartnerForView.communication_preference.aft_pur_email}
                                                                    {selectedPartnerForView.communication_preference.aft_pur_email_enabled && <span className="badge bg-success ms-2">Enabled</span>}
                                                                </div>
                                                                <small className="text-muted">Email</small>
                                                            </div>
                                                        </Col>
                                                    )}
                                                    
                                                    {selectedPartnerForView.communication_preference.aft_pur_phone && (
                                                        <Col lg={6} className="mb-3">
                                                            <div className="border-bottom pb-2">
                                                                <div className="fw-medium">
                                                                    {selectedPartnerForView.communication_preference.aft_pur_phone}
                                                                    {selectedPartnerForView.communication_preference.aft_pur_phone_enabled && <span className="badge bg-success ms-2">Enabled</span>}
                                                                </div>
                                                                <small className="text-muted">Phone</small>
                                                            </div>
                                                        </Col>
                                                    )}
                                                    
                                                    {selectedPartnerForView.communication_preference.aft_pur_whatsapp && (
                                                        <Col lg={6} className="mb-3">
                                                            <div className="border-bottom pb-2">
                                                                <div className="fw-medium">
                                                                    {selectedPartnerForView.communication_preference.aft_pur_whatsapp}
                                                                    {selectedPartnerForView.communication_preference.aft_pur_whatsapp_enabled && <span className="badge bg-success ms-2">Enabled</span>}
                                                                </div>
                                                                <small className="text-muted">WhatsApp</small>
                                                            </div>
                                                        </Col>
                                                    )}
                                                    
                                                    {selectedPartnerForView.communication_preference.aft_pur_calendly && (
                                                        <Col lg={6} className="mb-3">
                                                            <div className="border-bottom pb-2">
                                                                <div className="fw-medium">
                                                                    <a href={selectedPartnerForView.communication_preference.aft_pur_calendly} target="_blank" rel="noopener noreferrer" className="text-primary">
                                                                        Schedule Meeting <i className="bx bx-link-external"></i>
                                                                    </a>
                                                                    {selectedPartnerForView.communication_preference.aft_pur_calendly_enabled && <span className="badge bg-success ms-2">Enabled</span>}
                                                                </div>
                                                                <small className="text-muted">Calendly</small>
                                                            </div>
                                                        </Col>
                                                    )}
                                                    
                                                    {selectedPartnerForView.communication_preference.aft_pur_zoom && (
                                                        <Col lg={6} className="mb-3">
                                                            <div className="border-bottom pb-2">
                                                                <div className="fw-medium">
                                                                    <a href={selectedPartnerForView.communication_preference.aft_pur_zoom} target="_blank" rel="noopener noreferrer" className="text-primary">
                                                                        Join Meeting <i className="bx bx-link-external"></i>
                                                                    </a>
                                                                    {selectedPartnerForView.communication_preference.aft_pur_zoom_enabled && <span className="badge bg-success ms-2">Enabled</span>}
                                                                </div>
                                                                <small className="text-muted">Zoom</small>
                                                            </div>
                                                        </Col>
                                                    )}
                                                    
                                                    {selectedPartnerForView.communication_preference.aft_pur_teams && (
                                                        <Col lg={6} className="mb-3">
                                                            <div className="border-bottom pb-2">
                                                                <div className="fw-medium">
                                                                    <a href={selectedPartnerForView.communication_preference.aft_pur_teams} target="_blank" rel="noopener noreferrer" className="text-primary">
                                                                        Join Meeting <i className="bx bx-link-external"></i>
                                                                    </a>
                                                                    {selectedPartnerForView.communication_preference.aft_pur_teams_enabled && <span className="badge bg-success ms-2">Enabled</span>}
                                                                </div>
                                                                <small className="text-muted">Microsoft Teams</small>
                                                            </div>
                                                        </Col>
                                                    )}
                                                    
                                                    {selectedPartnerForView.communication_preference.aft_pur_notes && (
                                                        <Col lg={12} className="mb-3">
                                                            <div className="border-bottom pb-2">
                                                                <div className="fw-medium">{selectedPartnerForView.communication_preference.aft_pur_notes}</div>
                                                                <small className="text-muted">Notes</small>
                                                            </div>
                                                        </Col>
                                                    )}
                                                </>
                                            ) : (
                                                <Col lg={12}>
                                                    <div className="text-center text-muted py-4">No after-sale contact preferences set</div>
                                                </Col>
                                            )}
                                        </Row>
                                    </TabPane>
                                </TabContent>
                            </>
                        ) : (
                            <div className="text-center py-4">
                                <p className="text-muted">Loading partner details...</p>
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button 
                            type="button" 
                            className="btn btn-sm btn-primary" 
                            onClick={() => {closeViewPartner()}}
                        >
                            Close
                        </button>
                    </div>
                </Modal>
            </div>
        </div>
    );
};

export default AdminPartner;
